import React, { useState, useContext, useEffect } from 'react';

import { EyeIconSeen, EyeIconChecked } from './VisiblityEye.styles';
import { GlobalContext } from '../../../context/GobalState';

import VisibilitySharpIcon from '@mui/icons-material/VisibilitySharp';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import Slide from '@mui/material/Slide';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import axios from 'axios';

import { api } from '../../../api/api';

const Eye = ({ talk_id, isLastOpenItem, clickedStatus }) => {
  const { authToken, permissionLevel } = useContext(GlobalContext);
  const [seenStatus, setSeenStatus] = useState(false);
  const [checkedStatus, setCheckedStatus] = useState(false);
  const [alert, setAlert] = useState(false);
  const [click, setClick] = useState(false);

  useEffect(() => {
    if (talk_id !== '') {
      axios
        .get(`${api}data/record_checker/${talk_id}/`, {
          headers: {
            Authorization: `token ${authToken}`,
          },
        })
        .then(({ data }) => {
          setSeenStatus(data.is_seen);
          setCheckedStatus(data.is_checked);
        });
    }
  }, [talk_id, authToken, click, isLastOpenItem]);

  const handleSeen = () => {
    if (seenStatus) {
      axios
        .patch(
          `${api}data/record_checker/${talk_id}/`,
          { is_checked: true },
          {
            headers: {
              Authorization: `token ${authToken}`,
            },
          }
        )
        .then((response) => {
          if (response.status === 200) {
            setAlert(true);
            setClick(true);
            setTimeout(() => {
              setAlert(false);
              setClick(false);
            }, 2000);
          } else {
            setAlert(false);
            setClick(false);
          }
        });
    }
  };

  return (
    <>
      {alert ? (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: '50%',
            transform: 'translate(-50%, calc(-50% + 35px) )',
            zIndex: 1600,
          }}
        >
          <Slide direction="down" in={!!alert} mountOnEnter unmountOnExit>
            <Alert severity="success" sx={{ width: '600px' }}>
              {checkedStatus ? <p>Log checked!</p> : <p>Log unchecked!</p>}
            </Alert>
          </Slide>
        </Box>
      ) : (
        ''
      )}
      {checkedStatus ? (
        <div>
          <EyeIconChecked style={{ pointerEvents: 'none' }}>
            <VisibilitySharpIcon
              onClick={(e) => {
                e.stopPropagation();
                handleSeen();
              }}
            />
          </EyeIconChecked>
        </div>
      ) : seenStatus || clickedStatus ? (
        <div>
          <EyeIconSeen seenStatus={seenStatus}>
            <VisibilitySharpIcon
              onClick={(e) => {
                e.stopPropagation();
                handleSeen();
              }}
            />
          </EyeIconSeen>
        </div>
      ) : (
        <div>
          <EyeIconSeen seenStatus={seenStatus}>
            <VisibilityOffIcon
              onClick={(e) => {
                e.stopPropagation();
                handleSeen();
              }}
            />
          </EyeIconSeen>
        </div>
      )}
    </>
  );
};

export default Eye;
